module.exports = __webpack_public_path__ + "img/47_25.0fe477d8.png";